import React, { createContext, useContext, useState } from 'react';
import config from './config';

const IdentificationContext = createContext();

export const useIdentification = () => {
  const context = useContext(IdentificationContext);
  if (!context) {
    throw new Error('useIdentification must be used within an IdentificationProvider');
  }
  return context;
};

export const IdentificationProvider = ({ children }) => {
  const [identificationId, setIdentificationId] = useState(null);

  const createIdentification = async () => {
    try {
      const response = await fetch(`${config.API_BASE_URL}/identifications`, {
        method: 'POST'
      });
      
      if (!response.ok) {
        throw new Error('Failed to create identification');
      }
      
      const data = await response.json();
      setIdentificationId(data.id);
      return data.id;
    } catch (error) {
      console.error('Error creating identification:', error);
      throw error;
    }
  };

  return (
    <IdentificationContext.Provider value={{ identificationId, setIdentificationId, createIdentification }}>
      {children}
    </IdentificationContext.Provider>
  );
};
